import { AssetIcon, CrewIcon, FleetIcon, SafetyIcon } from 'assets/images/app-switcher-product-icons';
import './WebAppSwitcher.scss';
import { WaffleIcon } from 'assets/icons';
import WebAppSwitcherRow from './WebAppSwitcherRow';
import { Menu, Position, Divider } from '@busybusy/webapp-react-ui';
import { IconButton } from 'components';
import classNames from 'classnames';
import { ClassName } from 'types/ClassName';
import useAppSwitcherAnalytics from 'hooks/analytics/useAppSwitcherAnalytics';

export interface IWebAppSwitcherProps {
  title?: string;
  className?: ClassName;
}

export default function WebAppSwitcher({ title, className }: IWebAppSwitcherProps) {
  const mktBaseUrl = 'https://l.alignops.com/';
  const { recordAppSwitcherIconClick } = useAppSwitcherAnalytics();
  const appSwitchers = [
    {
      iconSrc: AssetIcon,
      appName: 'ToolWatch',
      appMktUrl: mktBaseUrl + 'toolwatch-in-app',
      appLoginUrl: 'https://cloud.alignops.com/login',
    },
    {
      iconSrc: SafetyIcon,
      appName: 'SafetyReports',
      appMktUrl: mktBaseUrl + 'safetyreports-in-app',
      appLoginUrl: 'https://admin.safety-reports.com/',
    },
    {
      iconSrc: CrewIcon,
      appName: 'BusyBusy',
      appMktUrl: mktBaseUrl + 'busybusy-in-app',
      appLoginUrl: 'https://app.busybusy.io/login',
    },
    {
      iconSrc: FleetIcon,
      appName: 'FleetWatcher',
      appMktUrl: mktBaseUrl + 'fleetwatcher-in-app',
      appLoginUrl: 'https://login.fleetwatcher.com/',
    },
  ];

  const classes = classNames('web-app-switcher', className);
  const handleAppSwitcherIconClick = () => {
    recordAppSwitcherIconClick();
  };

  return (
    <Menu
      className={classes}
      position={Position.BOTTOM_START}
      trigger={(ref: any) => (
        <div ref={ref}>
          <IconButton svg={WaffleIcon} onClick={handleAppSwitcherIconClick} />
        </div>
      )}
      content={() => (
        <div className="content-container">
          <div className="header-container">
            <h2>{title}</h2>
          </div>
          <Divider />
          <div className="body-container">
            {appSwitchers.map((appSwitcher, index) => (
              <WebAppSwitcherRow
                key={index}
                appIconSrc={appSwitcher.iconSrc}
                appName={appSwitcher.appName}
                appMktUrl={appSwitcher.appMktUrl}
                appLoginUrl={appSwitcher.appLoginUrl}
              />
            ))}
          </div>
        </div>
      )}
      width="350px"
    />
  );
}
